<template>
    <div class="container-fluid">
        
        <div class="row">
            
        <div class="offset-2 col-md-4 text-align-left">
                <strong>Hello,</strong>&nbsp;<br>
                My name is Eduardo Luz, and I am an I.T. professional with more than 20 years experience in software development. <br><br>On this page you can find a little bit about my work, some links to my social profiles, and projects that I have been working on.<br><br>Feel free to connect with me through 
                <a href="https://www.linkedin.com/in/eduluz" target="_blank">Linkedin</a>.
        </div>
        <div class="col-md-4" >
            <img class="photo" src="../assets/images/eduardo-main-384x384.jpg" alt="Eduardo Luz's picture" title="Eduardo Luz's picture">
        </div>

        </div>

    </div>
</template>

<script>
export default {
    
}
</script>

<style>


.photo {
    max-width: 60%;
}

</style>